/**
 * API contract for "Create Solution" on the New Resource Plan form.
 * Route: POST /api/plan-deal-options/:dealId/solution. Handler in
 * src/api/plan-deal-solution.ts.
 */
import { z } from "zod";

/** NOS's `Solution.Solution` limit, enforced by the Gateway endpoint too. */
export const DEAL_SOLUTION_NAME_MAX = 50;

export const createPlanDealSolutionSchema = z.object({
  /** The only field: everything else on the NOS Solution starts blank. */
  name: z
    .string({ message: "Give the Solution a name" })
    .trim()
    .min(1, { message: "Give the Solution a name" })
    .max(DEAL_SOLUTION_NAME_MAX, {
      message: `Keep the Solution name to ${DEAL_SOLUTION_NAME_MAX} characters (the NOS limit)`,
    }),
});
